import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchCatalog({ payload }) {
  try {
    const res = yield call(API.fetchAllTests, payload);
    const { data } = res;
    yield put(actions.fetchCatalogSuccess(data));
  } catch (err) {
    yield put(actions.fetchCatalogFailure(err?.response?.data));
  }
}

export function* handleCreateTestCategory({ payload }) {
  try {
    const res = yield call(API.addTestCategory, payload.data);
    const { data } = res;
    yield put(actions.saveTestCategorySuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.saveTestCategoryFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.saveTestCategoryFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleCreateCommodityCategory({ payload }) {
  try {
    const res = yield call(API.addCommodityCategory, payload.data);
    const { data } = res;
    yield put(actions.saveCommodityCategorySuccess(data));
    yield put(actions.fetchCommodityCategories());
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.saveCommodityCategoryFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.saveCommodityCategoryFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleCreateCommodity({ payload }) {
  try {
    const res = yield call(API.addCommodity, payload.data);
    const { data } = res;
    yield put(actions.saveCommoditySuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.saveCommodityFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.saveCommodityFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleFetchCommodityCategories({ payload }) {
  try {
    const res = yield call(API.fetchAllCommodityCategories, payload);
    const { data } = res;
    yield put(actions.fetchCommodityCategoriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommodityCategoriesFailure(err?.response?.data));
  }
}

export function* handleFetchCommodity({ payload }) {
  try {
    const res = yield call(API.fetchAllTestCommodities, payload);
    const { data } = res;
    yield put(actions.fetchCommoditySuccess(data));
  } catch (err) {
    yield put(actions.fetchCommodityFailure(err?.response?.data));
  }
}

export function* handleFetchTestCategory({ payload }) {
  try {
    const res = yield call(API.fetchAllTestCategories, payload);
    const { data } = res;
    yield put(actions.fetchTestCategorySuccess(data));
  } catch (err) {
    yield put(actions.fetchTestCategoryFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* masterCatalogSaga() {
  yield takeLatest(actions.fetchCatalog.type, handleFetchCatalog);
  yield takeLatest(actions.saveTestCategory.type, handleCreateTestCategory);
  yield takeLatest(
    actions.saveCommodityCategory.type,
    handleCreateCommodityCategory
  );
  yield takeLatest(actions.saveCommodity.type, handleCreateCommodity);
  yield takeLatest(
    actions.fetchCommodityCategories.type,
    handleFetchCommodityCategories
  );
  yield takeLatest(actions.fetchCommodity.type, handleFetchCommodity);
  yield takeLatest(actions.fetchTestCategory.type, handleFetchTestCategory);
}
